<template>
    <div class="top-menu">
        <div class="Tab">

            <ul class="top-list">
                <li class="top-menu-li" v-for="(item,index) in menu"  :class="{'top-menu-active':item.active}" @click="selectMenuType(index)" :key="index">
                    <div>{{item.name}}</div>
                    <div v-if="item.active" class="bottom-line"></div>
                </li>
            </ul>
            <!-- <div class="more-menu" @click="moreMenu" :class="{'navShowMroeselect':navShowMroeselect}">
            </div> -->
            <!-- 旧的筛选按钮
                <div class="classify" src="https://file.40017.cn/tcservice/wxapp/h5/image/assets/icon_sx.png" @click="toClasssify" ></div>
            -->
        </div>
       
        <!-- <div class="more-dialog" v-if="navShowMroeselect" :touchmove="defaultMove">
            <div class="dialog-content">
                <div class="dialog-title">
                    <h3>分类订单</h3>
                    <span @click="closeDialog"></span>
                </div>
                <div class="dialog-item-list"> 
                    <div class="dialog-item" v-for="(item,index) in moreSelectConfig" @click="toLInk(item.ID,item.Name)" :key="index">
                        <img class="dialog-item-img" :src="item.Icon">
                        <p>{{item.Name}}</p>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
    import axios from 'axios'
    import {api} from './../util/api.js'
    import moreSelectConfig from '../util/productIds.js'
    import Bus from '../components/bus.js'
    import {getCookie,changeTitle} from './../util/tool.js'
    export default {
        props:[ 'menu','nowActive'],
        data(){
            return {
                navShowMroeselect: false,
                isShowAnnoun: true,
                moreSelectConfig:moreSelectConfig
            }
        },
        mounted() {
           //请求过滤的列表
            let wxuser = getCookie('WxUser');
            let params = {
                openId: this.spliteWxUser(wxuser,'openid'),
                unionid: this.spliteWxUser(wxuser,'unionid')
            }
             axios.get(api.GetFilterProducts , {
                 params:params,
             }).then((res)=>{
                 if(res.data && res.data.Body && res.data.Body.Products && res.data.Body.Products.length > 0) {
                    let productIds = [...res.data.Body.Products]
                    this.moreSelectConfig =  productIds ;
                }
             }).catch((error)=>{

             })
            
        },
        methods:{
            //拿cookie WxUser中的openid
            spliteWxUser:function(rStr,str){
                try{
                    let a = rStr.split("&");
                    for (let i in a)
                        if (a[i].indexOf(str + "=") >= 0) {
                            let n = a[i].split("=");
                            if (null != n[1])
                                return n[1]
                        }
                    return ""
                }
                catch(e){
                }
                return ''
            },
            //跳转二级页面
            toLInk(type,Name){
                this.$router.push(`/list/${type}`);
                this.navShowMroeselect = false;
                this.menu[this.nowActive].active = 1;
                changeTitle(Name + "订单")
                Bus.$emit('fromIndexToNow',{type:type,name:Name})
                AppendTrack(category, action, label, '^分类订单^' + Name + '^');
            },
            toClasssify(){
                this.$router.push('/classifylist');
                changeTitle("分类查找订单")
                 AppendTrack(category, action, label, '^进入分类订单^');
            },
            //tab切换
            selectMenuType: function(index){                
                if(!this.menu[index].active){
                    for(let i  in this.menu){
                        this.menu[i].active = 0;
                    }
                    this.menu[index].active = 1;
                    this.$emit('selectMenuType' , {...this.menu[index],index:index});
                }
                this.navShowMroeselect = false;
                Bus.$emit('sortChange',index)
            },
            //点击更多
            moreMenu:function(event){
                for(let i  in this.menu){
                        this.menu[i].active = 0;
                }      
                this.navShowMroeselect = !this.navShowMroeselect;             
                if(!this.navShowMroeselect){
                    this.menu[this.nowActive].active = 1;
                }     
                      AppendTrack(category, action, label, '^分类订单^')  
            },
            //关闭弹窗
            closeDialog:function(){
                this.navShowMroeselect = false;
                this.menu[this.nowActive].active = 1;
            },
            //阻止页面穿透
            defaultMove:function(e){
                e.stopPropagation();
                
            }
        }
    }
</script>
<style scoped>
    .top-menu{
        height: 50px;
        font-size: 0;
        background:#fff;
        position: fixed;
        left:0;
        top: 0px;
        right: 0;
        max-width: 100%;
        z-index: 999;
        box-sizing: border-box;
    }
    ul, p{
        margin: 0;
        padding: 0;
    }
    .Tab{
         max-width: 100%;
         width: 100%;
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content:space-around;
        justify-content:space-between;
    }
    .classify{
         display: inline-block;
         vertical-align: middle;
         height: 50px;
         width: 50px;
         background: url(https://file.40017.cn/tcservice/wxapp/h5/image/assets/shaixuan_defaultsec.png) no-repeat;
         background-size: 20px 20px;
         background-position: 15px 17px;
    }

     .top-list{
        position: relative;
        display: -webkit-flex;
        display: flex;
        -webkit-justify-content:space-around;
        justify-content:space-around;
        margin-left: 0.3rem;
        -webkit-flex-grow: 1;
        flex-grow: 1;
    }
    .top-menu-li{
        font-size: 0.3rem;
        height: 47px;
        line-height: 47px;
        padding-top: 3px;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        -webkit-box-orient: vertical;
        text-align: center;
        display: -webkit-box;;
        color: #333;
        width: 1.5rem;
        position:relative;
      }
     .top-menu-li:last-child {
        margin-right: 0;
    }
     .top-menu-active{
         color: #16ba63;
         font-weight: bold;
     }
     .bottom-line{
        color: #16ba63;
        text-align:center;
        font-weight: 600;
        width: 1rem;
        height:2px;
        background: #16ba63;
        display: block;
        margin: 0 auto;
        position: absolute;
        bottom: 0;
        left:0;
        right:0;
     }
     .more-menu{
         display: inline-block;
         vertical-align: middle;
         height: 50px;
         width: 50px;
         background: url(../images/shaixuan_default.png) no-repeat;
         background-size: 20px 20px;
         background-position: center;
     }
     .navShowMroeselect{
         background: url(../images/shaixuan_pressed.png) no-repeat;
         background-size: 20px 20px;
         background-position: center;
     }
     .more-dialog{
         position: fixed;
         width: 100%;
         height: -webkit-calc(100% - 50px);
         background: rgba(0,0,0,0.6);    
         text-align: center;  
         z-index: 100;  
         left: 0;
         top: 50px;
         overflow:auto;
     }
     .dialog-title{
         width: 100%;
         height: 0.4rem;
         margin: 0.4rem 0 0.64rem 0;
         font-size: 0.36rem;
         font-weight: 600;
         position: relative;
     }
     .dialog-title h3{
         font-size: 0.36rem;
     }
     .dialog-title span{
         display: inline-block;
         width: 0.6rem;
         height: 0.6rem;
         background: url(../images/close.png) no-repeat;
         background-size: 0.3rem 0.3rem;
         background-position: center;
         position: absolute;
         right: 0;
         top: -0.4rem;
        margin: 0.2rem 0.2rem 0 0;
     }
     .dialog-content{
         width: 5.8rem;
         background: #fff;
         border-radius: 10px;
         height: 6.7rem;
         margin: auto 0; 
        left: 50%;
        top: 50%;
        -webkit-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
        position: absolute;
     }
     .dialog-item{
         
     }
     .dialog-content .dialog-item-list{
        display: -webkit-flex;
        display: flex;
        width: 5.7rem;
        padding: 0 0.05rem 0;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
     }
     .dialog-content .dialog-item-list .dialog-item{
 
        display: flex;
        display: -webkit-flex;
        -webkit-flex-direction: column;
        -webkit-justify-content: center;
        -webkit-align-items: center;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.45rem;
     }
      .dialog-content .dialog-item-list .dialog-item p{
          font-size: 0.26rem;
      }
     .dialog-item-img{
         width: 0.7rem;
         height: 32px;
         display: block;
         margin: 0 0.6rem 0.08rem;
     }
    
</style>


// WEBPACK FOOTER //
// src/components/navbar.vue